<template>
  <div class="point-settlement-base">
    <h3>ポイント利用の変更</h3>
    <div class="sec-remaining-point"><span>保有ポイント</span><span class="remain-point">{{ remainPoint | commaSeparator }}pt</span></div>
    <div class="sec-select-point-payment">
      <div class="radio-item">
        <input type="radio" name="paymentType" id="paymentType1" value="1" v-model.number="selectIdxLocal" @change="onRadioChange" />
        <label for="paymentType1">全額ポイントで支払う</label>
      </div>
      <div class="radio-item">
        <input type="radio" name="paymentType" id="paymentType0" value="0" v-model.number="selectIdxLocal" @change="onRadioChange" />
        <label for="paymentType0">ポイントを利用しない</label>
      </div>
    </div>
    <div class="sec-mess">※全額ポイント決済の場合は、ポイントを獲得できません。予めご了承ください。</div>
    <div class="sec-btn-update" @click="onUpdateClick"><span class="update-btn">更新する</span></div>
  </div>
</template>

<script>
export default {
  name: "PointSettlement",
  data() {
    return {
      dataChecked: false,
      selectIdxLocal: 0
    }
  },
  props: {
    selectIdxReceive: {
      type: Number,
      default() {
        return 0
      }
    },
    itemPrice: {
      type: Number,
      default() {
        return 0
      }
    },
    remainPoint: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  computed: {},
  mounted(){
    if(!this.dataChecked) {
      this.selectIdxLocal = this.selectIdxReceive
      this.dataChecked = true
    }
  },
  filters: {
    commaSeparator(val) {
      return String(val).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
  },
  methods: {
    onUpdateClick() {
      this.$emit('point-update', parseInt(this.selectIdxLocal))
      this.dataChecked = false
    },
    onRadioChange() {}
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/variables/index";
.point-settlement-base {
  width: 100%;
  padding: 44px 0;
  font-size: 14px;
  h3 {
    color: $gray-14;
    font-size: 12px;
    margin: 0;
    background: $gray-light;
    padding: 10px;
  }
  .sec-remaining-point {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    line-height: 1;
    .remain-point {
      color: $brand-2;
      font-size: 14px;
      font-weight: bold;
    }

  }
  .sec-select-point-payment {
    $btnW: 24px;
    width: 100%;
    border-top: 1px solid $gray-18;
    .radio-item {
      width: 100%;
      label {
        display: block;
        width: 100%;
        position: relative;
        padding: 16px 16px 16px ( $btnW + 16px + 8px );
        border-bottom: 1px solid $gray-18;
        cursor: pointer;
        &::before,
        &::after {
          content: '';
          width: $btnW;
          height: $btnW;
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          box-sizing: border-box;
          border-radius: $btnW / 2;
        }
        &::before {
          border: 1px solid $gray-14;
          width: $btnW;
          height: $btnW;
          left: 16px;
        }
        &::after {
          background: $gray-14;
          width: $btnW - 8px;
          height: $btnW - 8px;
          left: 20px;
          transition: all 200ms ease-out 0s;
          opacity: 0;
          transform: scale(0.5);
        }
      }

      input[type='radio'] {
        display: none;
        &:checked + label {
          &::after {
            opacity: 1;
            transform: scale(1);
          }
        }
      }
    }
  }
  .sec-mess {
    width: 100%;
    padding: 12px 16px;
    font-size: 12px;
    line-height: 15px;
  }
  .sec-btn-update {
    width: 100%;
    padding: 18px 16px 0;
    .update-btn {
      display: block;
      width: 100%;
      cursor: pointer;
      text-align: center;
      line-height: 1;
      font-size: 14px;
      font-weight: bold;
      padding: 13px;
      background: $black-0;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/PointSettlement.vue